import * as React from "react";

import { Container, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

import useSyncUpdates from "src/common/hooks/SyncUpdates";
import { WorkflowHome } from "src/domain/core/workflow/components/active/Workflow";
import { gpu } from "src/lib/tags";
import { useStyles } from "styles/global";

const Box = styled(Paper)(() => ({
  position: "relative",
  minHeight: "350px",
  borderRadius: "15px",
  padding: "25px",
  marginBottom: "15px",
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 8px",
  transition: "max-height 0.3s ease-out",
}));

interface ActiveWorkflowsProps {
  workflows: Array<Workflow>;
  nodes: Nodes;
}

export const ActiveWorkflows: React.FC<ActiveWorkflowsProps> = ({ workflows, nodes }) => {
  const classes = useStyles();

  const { sync, triggerSync } = useSyncUpdates();

  React.useEffect(() => {
    if (workflows) {
      triggerSync(); // Used to synchronize the flash animation on all workflows
    }
  }, [workflows, triggerSync]);

  // Collects the appropriate nodes based on the workflow node type
  const collectNodes = (wf: Workflow) => {
    return wf.tags[gpu]
      ? {
          head: nodes?.gpus?.head,
          compute: nodes?.gpus?.compute,
        }
      : {
          head: nodes?.cpus?.head,
          compute: nodes?.cpus?.compute,
        };
  };

  return (
    <>
      {workflows && workflows.length > 0 && (
        <Container className={classes.containerLoad}>
          {workflows.map((workflow) => {
            return (
              <Box key={workflow.id} className={classes.styledPaper}>
                <WorkflowHome
                  key={workflow.name}
                  workflow={workflow}
                  nodes={collectNodes(workflow)}
                  syncKey={sync(workflow.name)}
                />
              </Box>
            );
          })}
        </Container>
      )}
      {workflows && workflows.length === 0 && <div className="centered-disp">No active workflows</div>}
    </>
  );
};
